var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticStyle:{"margin-top":"100px"},attrs:{"align-center":"","column":""}},[_c('p',{staticClass:"Section-Title"},[_vm._v("Posisi yang Tersedia")]),_c('div',{style:({ width: _vm.widthComponent })},[_c('v-divider'),_vm._l((_vm.positions),function(data,i){return _c('recruitment-content',{key:i,attrs:{"data":data}})})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }